import { render } from "./TranslatableField.vue?vue&type=template&id=e2eafcb4"
import script from "./TranslatableField.vue?vue&type=script&lang=js"
export * from "./TranslatableField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TranslatableField.vue"]])

export default __exports__